import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserApi } from '../../api';
import { User } from '../../shared';


@Injectable()
export class UsersFacade {
	constructor(private userApi: UserApi) { }

	public getUsers(): Observable<User[]> {
		return this.userApi.getUsers();
	}

	/**
     * postUserNewData
     */
	public postUserNewData(userData) {
		this.userApi.postUserNewData(userData);
	}

}
